export function generateValidId(inputString) {
  const sanitized = inputString.trim().replace(/[^a-zA-Z0-9_-]/g, '_');

  if (/^[0-9]/.test(sanitized)) {
    return '_' + sanitized;
  }

  return sanitized;
}
